import React from "react"
import { formatMoney } from "../transactions/format"
import { PlanBreakdown } from "../home/PlanBreakdown"

// Summary cards: active count, MRR, frozen, 30d churn + plan breakdown bar list.
export function SubscriptionSummary({ summary, copy }) {
  const card = "rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
  const label = "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400"
  const value = "mt-1 text-lg font-semibold text-gray-900 dark:text-gray-100"

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <div className={card}>
          <div className={label}>{copy.summary.active}</div>
          <div className={value}>{summary.active?.toLocaleString() ?? "—"}</div>
        </div>
        <div className={card}>
          <div className={label}>{copy.summary.mrr}</div>
          <div className={value}>{formatMoney(summary.mrr_cents, summary.currency)}</div>
        </div>
        <div className={card}>
          <div className={label}>{copy.summary.frozen}</div>
          <div className={value}>{summary.frozen?.toLocaleString() ?? "—"}</div>
        </div>
        <div className={card}>
          <div className={label}>{copy.summary.cancelled_30d}</div>
          <div className={value}>{summary.cancelled_30d?.toLocaleString() ?? "—"}</div>
        </div>
      </div>

      {summary.by_plan?.length > 0 && (
        <div className={card}>
          <div className={`${label} mb-3`}>{copy.summary.plan_breakdown}</div>
          <PlanBreakdown
            plans={summary.by_plan}
            emptyLabel="—"
            paidLabel={copy.summary.plan_breakdown_paid}
            freeLabel={copy.summary.plan_breakdown_free}
          />
        </div>
      )}
    </div>
  )
}
